import getCharts from '../getCharts'
import { Labs } from '../../constants/api.config'

export default async function LabCRUD(Mode , labInformation="", labID="") {
  try {
    const payload = {mode:Mode, labInformation, labID}
    const res = await getCharts(Labs, payload)
    return res.data
  } catch (error) {
    return error
  }
}
